"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentGoogleMapConfig = void 0;
const InputLoading_1 = __importDefault(require("../components/inputs/InputLoading"));
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
const googleMapConfigNew = {
    id: 'google-map-script',
    googleMapsApiKey: process.env.GOOGLE_API_KEY,
    libraries: ['places', 'geometry']
};
// Legacy google map configuration, still used in old PhotonOsmInputMap component
exports.default = {
    apiKey: process.env.GOOGLE_API_KEY,
    LoadingContainer: InputLoading_1.default,
    libraries: ['places', 'geometry']
};
// The google map configuration needs to be global as the loading of the API
// takes place once for the whole survey and the configuration cannot change,
// even between sections, otherwise it throws an exception.
let currentGoogleMapConfig = undefined;
const getCurrentGoogleMapConfig = (language = project_config_1.default.defaultLocale) => {
    if (currentGoogleMapConfig) {
        return currentGoogleMapConfig;
    }
    currentGoogleMapConfig = Object.assign({ region: project_config_1.default.region, language: language }, googleMapConfigNew);
    return currentGoogleMapConfig;
};
exports.getCurrentGoogleMapConfig = getCurrentGoogleMapConfig;
//# sourceMappingURL=googleMaps.config.js.map